<template>
  <v-row>
    <v-col cols="12">
      <file-input-com-data-table
        label="Anexar documentos"
        no-data-message="Nenhum anexo adicionado"
        :loading="loading"
        :lista-de-arquivos="anexos"
        @update:lista-de-arquivos="handleUploadAnexos"
      />
    </v-col>
  </v-row>
</template>

<script>
import FileInputComDataTable from '@/components/file-input/FileInputComDataTable.vue'

export default {
  components: {
    FileInputComDataTable,
  },

  emits: ['update:anexos'],

  props: {
    loading: {
      type: Boolean,
      required: false,
    },
    anexos: {
      type: Array,
      default: null,
    },
  },

  setup(_, { emit }) {
    function handleUploadAnexos(files) {
      emit('update:anexos', files)
    }

    return {
      handleUploadAnexos,
    }
  },
}
</script>
